import { Component, HostListener, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router, RouterModule } from '@angular/router';
import { AuthService } from '../../../core/auth/auth.service';
import { ProfileService } from '../../../core/services/profile/profile.service';
import { DialogService } from '../dialog/dialog.service';

@Component({
    selector: 'app-header',
    standalone: true,
    imports: [CommonModule, RouterModule],
    templateUrl: './header.component.html',
    styles: []
})
export class HeaderComponent {
    authService = inject(AuthService);
    profileService = inject(ProfileService);
    dialogService = inject(DialogService);
    router = inject(Router);
    isDropdownOpen = false;

    get username(): string {
        return this.profileService.username;
    }

    get isDialogOpen() {
        return this.dialogService.getIsDialogOpen();
    }

    logout() {
        this.authService.logout();
        this.router.navigate(['/login']);
    }

    getInitials(name: string): string {
        const [first, last] = name?.trim().split('.');
        return `${first?.[0] ?? ''}${last?.[0] ?? ''}`.toUpperCase();
    }

    isTransactionPage(): boolean {
        return this.router.url === '/transactions';
    }

    toggleDropdown() {
        this.isDropdownOpen = !this.isDropdownOpen;
    }

    @HostListener('document:click', ['$event'])
    onClickOutside(event: Event) {
        const target = event.target as HTMLElement;
        if (!target.closest('.relative')) {
            this.isDropdownOpen = false;
        }
    }
} 